export const MY_SCOPE_ID = "my-scope";

export function toScopeSelectedKeys(selectedIds: string[], callerId: string): string[] {
    return selectedIds.map(id => (id === callerId ? MY_SCOPE_ID : id));
}

export function resolveScopeSelection(next: string[], callerId: string): string[] {
    return next.map(id => (id === MY_SCOPE_ID ? callerId : id));
}
